import React from 'react'
import { TypeSectionCitationRules, TypeSectionCitationRulesFields } from '../../../lib/types/section-citation-rules'
import { KeywordSourceTypeRelationship } from '../../../lib/types/citation-keyword-metadata'
import { useCitationProgrammaticPageContext } from '../../../contexts/citation-programmatic-page-context'
import { PageSection } from '../../page-section'
import { ContentProps } from '../../renderer'

export const CitationRulesSection: React.FC<ContentProps<TypeSectionCitationRules>> = ({ structure }) => {
  const {
    sys,
    fields: { internalName, background, alignment },
  } = structure
  const { sourceTypeRelationship } = useCitationProgrammaticPageContext()

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      background={background}
      alignment={alignment}
      heading={getHeadingBySourceTypeRelationship(structure.fields, sourceTypeRelationship)}
    />
  )
}

// #ToDo refactor to avoid fallthrough
/* eslint-disable no-fallthrough */
const getHeadingBySourceTypeRelationship = (
  fields: TypeSectionCitationRulesFields,
  sourceTypeRelationship?: KeywordSourceTypeRelationship
) => {
  switch (sourceTypeRelationship) {
    case KeywordSourceTypeRelationship.Equal:
      if (fields.headingProgrammaticEqual) {
        return fields.headingProgrammaticEqual
      }
    case KeywordSourceTypeRelationship.Mapped:
      if (fields.headingProgrammaticMapped) {
        return fields.headingProgrammaticMapped
      }
    case KeywordSourceTypeRelationship.MostCommonly:
      if (fields.headingProgrammaticMostCommonly) {
        return fields.headingProgrammaticMostCommonly
      }
    default:
      return fields.heading
  }
}
/* eslint-enable no-fallthrough */
